import { useAuth } from '@/contexts/AuthContext';
import { useCampaignStore } from '@/stores';

/**
 * Whether the user may make the selected campaign's campaign-wide changes: the voter file and
 * billing. The client side of the API's `[RequireFullAdmin]`: a platform admin, or the
 * campaign's full admin (owner or FullAdmin preset).
 */
export function useMayManageCampaign(): boolean {
  const { user } = useAuth();
  const isFullAdmin = useCampaignStore((s) => s.isFullAdmin());
  return (user?.isPlatformAdmin ?? false) || isFullAdmin;
}
